export const gallery = [
  { id: 1, image: require("../assets/gallery/1.jpg") },
  { id: 2, image: require("../assets/gallery/2.jpg") },
  { id: 3, image: require("../assets/gallery/3.jpg") },
  { id: 4, image: require("../assets/gallery/4.jpg") },
  { id: 5, image: require("../assets/gallery/5.jpg") },
  { id: 6, image: require("../assets/gallery/6.jpg") },
  { id: 7, image: require("../assets/gallery/7.jpg") },
  { id: 8, image: require("../assets/gallery/8.jpg") },
  { id: 9, image: require("../assets/gallery/9.jpg") },
  { id: 10, image: require("../assets/gallery/10.jpg") },
  { id: 11, image: require("../assets/gallery/11.jpg") },
  { id: 12, image: require("../assets/gallery/12.jpg") },
  { id: 13, image: require("../assets/gallery/13.jpg") },
  { id: 14, image: require("../assets/gallery/14.jpg") },
  { id: 15, image: require("../assets/gallery/15.jpg") },
  { id: 16, image: require("../assets/gallery/16.jpg") },
  { id: 17, image: require("../assets/gallery/17.jpg") },
  { id: 18, image: require("../assets/gallery/18.jpg") },
  { id: 19, image: require("../assets/gallery/19.jpg") },
  { id: 20, image: require("../assets/gallery/20.jpg") },
  { id: 21, image: require("../assets/gallery/21.jpg") },
  { id: 22, image: require("../assets/gallery/22.jpg") },
  { id: 23, image: require("../assets/gallery/23.jpg") },
  { id: 24, image: require("../assets/gallery/24.jpg") },
  { id: 25, image: require("../assets/gallery/25.jpg") },
  { id: 26, image: require("../assets/gallery/26.jpg") },
  { id: 27, image: require("../assets/gallery/27.jpg") },
  { id: 28, image: require("../assets/gallery/28.jpg") },
  { id: 29, image: require("../assets/gallery/29.jpg") },
  { id: 30, image: require("../assets/gallery/30.jpg") },
  { id: 31, image: require("../assets/gallery/31.jpg") },
  { id: 32, image: require("../assets/gallery/32.jpg") },
  { id: 33, image: require("../assets/gallery/33.jpg") },
  { id: 34, image: require("../assets/gallery/34.jpg") },
  { id: 35, image: require("../assets/gallery/35.jpg") },
  { id: 36, image: require("../assets/gallery/36.jpg") },
  { id: 37, image: require("../assets/gallery/37.jpg") },
  { id: 38, image: require("../assets/gallery/38.jpg") },
  { id: 39, image: require("../assets/gallery/39.jpg") },
  { id: 40, image: require("../assets/gallery/40.jpg") },
];
